import { Application } from "@hotwired/stimulus"
import { Autocomplete } from "stimulus-autocomplete"
import { useClickOutside } from 'stimulus-use'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

export default class extends Autocomplete {
  connect() {
    super.connect();
    useClickOutside(this)
  }

  clickOutside(event) {
    if (this.hiddenTarget.value == null || this.hiddenTarget.value == '' || this.hiddenTarget.value == undefined) {
      this.inputTarget.value = '';
    }
  }
}